/** @description 信贷客户的平台总授信额度判定阈值 */
export const CREDIT_CUSTOMER_KLIMK_THRESHOLD = 10

/**
 * @description 根据平台总授信额度判断商城客户结算类型
 * @reason 商城业务约定 klimk 大于 10 为信贷客户，其余情况均为现款客户
 * @param {number|string|null|undefined} klimk - 平台总授信额度
 * @returns {boolean} 是否为信贷客户
 */
export function isCreditCustomerByKlimk(klimk) {
  const totalQuota = Number(klimk)
  return Number.isFinite(totalQuota) && totalQuota > CREDIT_CUSTOMER_KLIMK_THRESHOLD
}

/**
 * @description 读取个人中心现款客户的可用余额
 * @reason 余额必须使用与收银台一致的 balance.available，不得回退到授信字段 kyed
 * @param {Record<string, unknown> | null | undefined} funds - 个人中心资金接口或用户状态
 * @returns {number} 可用于展示的余额；缺失或无效时返回 0
 */
export function getCashAvailableBalance(funds) {
  if (!funds || typeof funds !== 'object') return 0
  const nestedBalance =
    funds.balance && typeof funds.balance === 'object' ? funds.balance.available : undefined
  const amount = Number(funds.cashAvailableBalance ?? nestedBalance)
  return Number.isFinite(amount) ? amount : 0
}

/**
 * @description 将个人中心资金接口响应规范化为可安全覆盖 Pinia 的完整字段
 * @reason setUserInfo 会过滤 null/undefined，因此必须先将空响应归零，避免保留上一次资金数据
 * @param {Record<string, unknown> | null | undefined} quota - 个人中心资金接口响应
 * @returns {{
 *   manufacturerQuotaRemain: number|string,
 *   manufacturerQuotaTotal: number|string,
 *   cashAvailableBalance: number|string,
 *   kyed: number|string,
 *   klimk: number|string,
 *   manufacturerQuotaOverdue: boolean,
 * }}
 */
export function normalizeAccountFundsPayload(quota) {
  const source = quota && typeof quota === 'object' ? quota : {}
  const balance =
    source.balance && typeof source.balance === 'object' ? source.balance.available : undefined

  return {
    manufacturerQuotaRemain: source.manufacturerQuotaRemain ?? source.kyed ?? 0,
    manufacturerQuotaTotal: source.manufacturerQuotaTotal ?? source.klimk ?? 0,
    cashAvailableBalance: balance ?? 0,
    kyed: source.kyed ?? source.manufacturerQuotaRemain ?? 0,
    klimk: source.klimk ?? source.manufacturerQuotaTotal ?? 0,
    manufacturerQuotaOverdue: source.manufacturerQuotaOverdue === true,
  }
}
